export default __webpack_public_path__ + "b977420275f032cefe2a4681870a4669.svg";